import type { CallAnalysisIntent, CallAnalysisTopic } from '@marnic/shared';
import { sentimentStyle } from '../primitives/SentimentChip';
import { EvidenceBadge } from '../EvidenceBadge';

export function IntentTopicChips({ intents, topics }: { intents: CallAnalysisIntent[] | null; topics: CallAnalysisTopic[] | null }): JSX.Element | null {
  if ((!intents || intents.length === 0) && (!topics || topics.length === 0)) return null;
  return (
    <div className="space-y-1.5">
      {intents && intents.length > 0 && (
        <div className="flex flex-wrap items-center gap-1">
          {intents.map((i, idx) => (
            <span
              key={idx}
              className="inline-flex items-center gap-1 rounded border border-ink-200 bg-ink-50 px-2 py-0.5 text-[11px]"
              title={i.evidence ? `${Math.round((i.confidence ?? 1) * 100)}% — “${i.evidence}”` : `${Math.round((i.confidence ?? 1) * 100)}%`}
            >
              {i.code.replace(/_/g, ' ')}
              {i.evidenceId && <EvidenceBadge id={i.evidenceId} />}
            </span>
          ))}
        </div>
      )}
      {topics && topics.length > 0 && (
        <div className="flex flex-wrap gap-1">
          {topics.map((t, idx) => (
            <span
              key={idx}
              className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[11px] ${sentimentStyle(t.sentiment)}`}
            >
              {t.label}
              {t.frequency > 1 && <sup className="text-[9px]">×{t.frequency}</sup>}
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
